<template>
	<section class="download-center-layout-wrapper">
		<div v-if="full_report" class="row">
			<div class="columns small-12 medium-10 medium-offset-1 xlarge-8 xlarge-offset-2">
				<a :href="full_report.file" :class="['button', 'dark', 'icon-with-right-text', 'download-files']" target="_blank">
					<span class="title" v-text="$t('download_full_report')"></span>
					<span class="text-right" v-text="fullReportSize"></span>
				</a>
			</div>
		</div>
		<div class="row">
			<div class="columns small-12 medium-10 medium-offset-1 xlarge-5 xlarge-offset-2">
				<section v-for="(chapter, index) in chapters" :key="'chapter-' + index" :class="[{active: chapter.selected}]">
					<a href="#" v-on:click.stop.prevent="toggleChapter(index)" @keyup.enter="toggleChapter(index)" 
					v-bind:class="['chapter-toggle', 'button', 'accordion-arrow', 'icon-with-right-text', { active: chapter.selected }]">
						<span class="title" v-html="chapter.title"></span>
						<span class="text-right" v-if="countReady">(<span class="count" :key="'count-' + index" v-html="chapter.selectedCount || 0"></span> / <span class="total" v-html="chapter.totalCount || 0"></span>)</span>
					</a>
					<div class="chapter-downloads-wrapper" v-if="chapter.selected">
						<div class="row">
							<div class="chapter-downloads-articles columns collapse small-12 medium-8">
								<h3 v-text="$t('pages')"></h3>
								<nav v-if="chapter.articles">
									<button-download v-for="(article) in chapter.articles" 
									:key="'article-' + article.slug" type="article" v-bind:item="article" classes="plain" v-bind:itemId="article.id"></button-download>
								</nav>
							</div>
							<div class="chapter-downloads-images columns collapse small-12 medium-4">
								<h3 v-text="$t('graphics')"></h3>
								<nav v-if="chapter.graphs">
									<button-download v-for="(graph) in chapter.graphs" 
									type="graph" 
										:key="'graph-' + graph.slug" 
										:item="graph" 
										:itemId="graph.id" 
										classes="plain"></button-download>
								</nav>
							</div>
						</div>
					</div>
				</section>
			</div>
			<div class="columns small-12 medium-10 medium-offset-1 xlarge-offset-0 xlarge-pull-1 xlarge-3">
				<aside class="downloads-aside-wrapper">
					<a href="#" v-on:click.stop.prevent="downloadFile()" @keyup.enter="downloadFile()" v-bind:class="['button', 'icon-with-right-text', 'download-files']">
						<span class="title" v-text="$t('download')"></span>
						<span class="text-right" v-if="countReady" v-text="downloadSize"></span>
					</a>
					<div v-if="addedFiles">
						<button-download v-for="(file, fileIndex) in addedFiles" 
							:key="'file-' + fileIndex" 
							:type="file.type" 
							:item="file" 
							:itemId="file.id" 
							classes="plain" 
							showActiveOnly="true"
							useFilename="true"></button-download>
					</div>
				</aside>
			</div>
		</div>
	</section>
</template>

<style lang="scss">
  @import "../../styles/scss/component/download-center-layout";
</style>

<script>
import { mapState, mapActions } from 'vuex'
import ButtonDownload from './downloads/ButtonDownload'

export default {
	props: ['chapters', 'full_report'],
	data() {
		return {
			selectedIds: [],
			localChapterData: {},
			countReady: false,
			addedFiles: [],
			filesize: 0
		}
	},
	components: {
		ButtonDownload,
	},
	computed: {
		...mapState({
			lang: state => state.lang
		}),
		...mapState('downloads', {
			selectedArticles: state => state.article,
			selectedNotes: state => state.note,
			selectedGraphs: state => state.graph,
		}),
		downloadSize() {
			return (this.filesize/1000000).toFixed(2) + ' MB';
		},
		fullReportSize() {
			return (this.full_report.size/1000000).toFixed(2) + ' MB';
		}
	},
	methods: {
		...mapActions('downloads', {
			getAllIds: 'getAllIds',
			generateUserPdf: 'generateUserPdf'
		}),
		downloadFile() {
			this.$http.post(window.dcSite.apiRoute + 'download/custom-pdf', { 
				articleIds: this.selectedArticles.join(','),
				noteIds: this.selectedNotes.join(','),
				graphIds: this.selectedGraphs.join(',')
			}).then(response => {
				if (response.data.success) {
					if (typeof response.data.file !== 'undefined') {
						if (typeof response.data.blob !== 'undefined') {
							//console.log('To Do');
						} else if (typeof response.data.file !== 'undefined') {
							window.open(response.data.file, '_blank');
						}
					}
				}
			});
		},
		toggleChapter(index) {
			this.chapters[index].selected = !this.chapters[index].selected
		},
		filter(files, chapterKey, startFromZero) {
			var totalCount = (startFromZero) ? 0 : this.chapters[chapterKey].totalCount;
			var selectedCount = (startFromZero) ? 0 : this.chapters[chapterKey].selectedCount;
			for (var i = 0; i < files.length; i++) {
				totalCount++;
				if (this.selectedIds.indexOf(files[i].id)!==-1) {
					selectedCount++;
					if (typeof files[i].pdf !== 'undefined') {
						this.filesize += parseInt(files[i].pdf.size);
					} else if (typeof files[i].image !== 'undefined') {
						this.filesize += parseInt(files[i].image.size);
					}
					this.addedFiles.push(files[i])
				}
			}
			this.chapters[chapterKey].totalCount = totalCount;
			this.chapters[chapterKey].selectedCount = selectedCount;
		},
		updateCounts() {
			this.getAllIds().then((value) => {
				this.countReady = false;
				this.selectedIds = value;
				this.addedFiles = [];
				this.filesize = 0;
				this.totalFilesCount = 0;
				for (var i = 0; i < this.chapters.length; i++) {
					var chapter = this.chapters[i];
					if (chapter.articles.length>0) this.filter(chapter.articles, i, true)
					if (chapter.notes.length>0) this.filter(chapter.notes, i, false)
					if (chapter.graphs.length>0) this.filter(chapter.graphs, i, false)
				}
				if (this.addedFiles.length===0) {
					this.addedFiles = false
				}
				this.countReady = true;
			});
		}
	},
	created() {
		this.updateCounts()
	},
	watch: {
		'$route': 'updateCounts',
		'selectedArticles': 'updateCounts',
		'selectedNotes': 'updateCounts',
		'selectedGraphs': 'updateCounts',
	}
}
</script>